import { Types } from './actionTypes';

const initialState = {
  profile: {
    userName: '',
    name: '',
    emailId: '',
    salesPersonId: 0
  },
  party: null,
  sale: null,
  isUserLoggedIn: false
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.LOGIN:
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
            ...state,
            profile: action.payload.user,
            isUserLoggedIn: true
      }
    case Types.LOGOUT:
      console.log("Logging out");
      localStorage.clear();
      return {
            ...state,
            profile: initialState,
            isUserLoggedIn: false
        }    
    case Types.SELECT_CUSTOMER:
          return {
                ...state,
                party: action.payload
          }
    case Types.SELECT_SALE:
          return {
                ...state,
                sale: action.sale
          }
    default:
      return state;
  }
}

export default reducer;